import _ from 'lodash'

interface XYLayout {
	x: number
	y: number
	width: number
	height: number
	rotationInDegrees?: number
}

function roundToNearestHalf(num: number) {
	return Math.round(num * 2) / 2
}

function degreesToRadians(angleInDegrees: number) {
	return (angleInDegrees * Math.PI) / 180
}

const getBoundingWidthWithRotation = (layout: XYLayout, angleInRadians: number) => {
	const boundingWidthWithRotation =
		Math.abs(layout.width * Math.cos(angleInRadians)) + Math.abs(layout.height * Math.sin(angleInRadians))
	return roundToNearestHalf(boundingWidthWithRotation)
}

const getBoundingHeightWithRotation = (layout: XYLayout, angleInRadians: number) => {
	const boundingHeightWithRotation =
		Math.abs(layout.width * Math.sin(angleInRadians)) + Math.abs(layout.height * Math.cos(angleInRadians))
	return roundToNearestHalf(boundingHeightWithRotation)
}

const getXAfterRotation = (layout: XYLayout, rotatedWidth: number) =>
	roundToNearestHalf(layout.x - (rotatedWidth - layout.width) / 2)

const getYAfterRotation = (layout: XYLayout, rotatedHeight: number) =>
	roundToNearestHalf(layout.y - (rotatedHeight - layout.height) / 2)

const rotateAndGetBoundingLayout = (layout: XYLayout, rotationInDegrees: number) => {
	if (rotationInDegrees === 0) {
		return _.pick(layout, ['x', 'y', 'width', 'height'])
	}

	const angleInRadians = degreesToRadians(rotationInDegrees)
	const boundingWidth = getBoundingWidthWithRotation(layout, angleInRadians)
	const boundingHeight = getBoundingHeightWithRotation(layout, angleInRadians)
	return {
		x: getXAfterRotation(layout, boundingWidth),
		y: getYAfterRotation(layout, boundingHeight),
		width: boundingWidth,
		height: boundingHeight,
	}
}

export const getBoundingLayout = (layout: XYLayout) => rotateAndGetBoundingLayout(layout, layout.rotationInDegrees || 0)
